import React from "react";

export default function Shipping() {
  return <h1>Shipping Policy</h1>;
}
